/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import EditContainer from './edit';
import EditElement from './edit.element';
import SaveElement from './save.element';
import EditResult from './edit.result';
import SaveResult from './save.result';
import Save from './save';
import metadata from './block.json';

/**
 * Icons
 */
import icons from './icons.js';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
    title: __( 'MoMo Form Container', 'momoacg' ),
    icon: icons.content,
    category: 'common',
    attributes: {
        header: {
          type: 'string',
          default: '',
        },
        subHeader: {
          type: 'string',
          default: '',
        },
    },
    supports: {
      multiple: false, // Allow only one instance of this block per post
    },
    templateLock: false,
    /**
     * @see ./edit.js
     */
    edit: EditContainer,

    /**
     * @see ./save.js
     */
    save: Save,
} );

registerBlockType( 'momo-acg-forms/momo-form-elements', {
    title: __( 'MoMo Form Elements', 'momoacg' ),
    icon: icons.content,
    category: 'common',
    attributes: {
        selectedElement: {
          type: 'string',
          default: 'text',
        },
        textContent: {
          type: 'string',
          default: '',
        },
        textareaContent: {
          type: 'string',
          default: '',
        },
        selectOptions: {
          type: 'array',
          default: [{ label: '', value: '' }],
        },
        radioOptions: {
          type: 'array',
          default: [{ label: '', value: '' }],
        },
        checkOptions: {
          type: 'array',
          default: [{ label: '', value: '' }],
        },
        elementLabel: {
            type: 'string',
            default: __('Label', 'momoacg')
        },
        elementID: {
            type: 'string',
            default: '',
        },
    },
    edit: EditElement,
    save: SaveElement,
} );
registerBlockType( 'momo-acg-forms/momo-form-result', {
    title: __( 'MoMo Form Result', 'momoacg' ),
    icon: icons.content,
    category: 'common',
    attributes: {
      customPrompt: {
        type: 'string',
        default: '',
      },
      submitText: {
        type: 'string',
        default: __('Submit', 'momoacg'),
      },
    },
    edit: EditResult,
    save: SaveResult,
} );
